import { Button } from "./Button";
import { Styles } from "./Styles";
import { UIGroup } from "./UIGroup";
export class Tab extends UIGroup {
    constructor() {
        super();
        this._stateNum = Styles.buttonStateNum;
    }
    createItem(skin, label) {
        let btn = new Button();
        btn._skinBaseUrl = this._skinBaseUrl;
        if (skin)
            btn.skin = skin;
        btn.label = label;
        return btn;
    }
}
